
import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1A2332] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="world-map" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="1" fill="white" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#world-map)" />
        </svg>
      </div>
      
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-8 py-10 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-8 md:mb-12">
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2 mb-3 md:mb-4">
              <img 
                src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/a22c6f10bd0fd012fb853447cad680f4.jpeg" 
                alt="スーパースプーン" 
                className="h-6 w-6 md:h-8 md:w-8 object-contain"
              />
              <h3 className="text-lg md:text-xl font-bold">
                スーパースプーン<span className="text-primary">.</span>
              </h3>
            </div>
            <p className="text-white/70 text-xs md:text-sm leading-relaxed mb-4 md:mb-6">
              中小EC向け業務設計×自動化コンサルティング。<br />
              EC運営を1日5分に。
            </p>
          </div>
          
          <div>
            <h4 className="font-bold mb-3 md:mb-4 text-sm md:text-base">サービス</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  自動化診断
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  基盤構築
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  運用顧問
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-3 md:mb-4 text-sm md:text-base">料金</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  診断プラン
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  構築プラン
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  運用顧問プラン
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-3 md:mb-4 text-sm md:text-base">サポート</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  よくある質問
                </button>
              </li>
              <li>
                <Link
                  to="/company"
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  会社概要
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  お問い合わせ
                </button>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-white/70 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
                >
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-6 md:pt-8">
          <p className="text-xs md:text-sm text-white/60 text-center">
            © 2025 スーパースプーン. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
